<template>
  <div class="app flex-row align-items-center">
    <div class="container" align="center">
      <img style="margin-top: -150px; padding-bottom: 20px; height: 200px;" src="/static/img/getlocal-logo.png" />
      <div class="row justify-content-center">
        <div class="col-md-4" align="center">
          <div class="card-group mb-0">
            <div class="card p-4">
              <div class="card-block">
                <h1>Login</h1>
                <p class="text-muted">Sign In to your account</p>
                <img src="/static/img/google_signin_buttons/web/1x/btn_google_signin_dark_normal_web.png" class="sign-in-button" @click="signIn">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/* eslint-disable */
export default{
  data: function(){
    return {

    }
  },
  components : {

  },
  methods: {
    signIn : function(){
      var provider = new firebase.auth.GoogleAuthProvider();
      firebase.auth().signInWithRedirect(provider);
    }
  },
  computed: {
  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?7b650e92